<template>
  <div class="maxbox">
    <div>
      <div class="top"><br>
        <!-- <div id="walletAddress">{{ shortWalletAddress }}</div>
        <div id="walletBalanceTop">金额: {{ walletBalanceTop }} USDT</div> -->
        <div id="walletBalanceScore" style="color:yellow;">积分: {{ points }} 分</div>
      </div>
      <div class="main">
        <div class="itemheader">
          <img src="@/assets/images/ban-2.png" alt="" />
          <div>
            <h2>SCPs ECOL OGY</h2>
            <p>开创区块链新时代</p>
          </div>
        </div>

        <h3 class="title">订单详情</h3>

        <div class="card">
          <form @submit.prevent="handleSubmit">
            <label for="address">收货地址:</label>
            <input type="text" id="address" v-model="addressInfo" required class="input-field" />
            
            <label for="name">
  姓名/
  <span style="color: red;">电话号码:</span>
</label>
            <textarea
              id="name"
              v-model="name"
              required
              class="input-field autoresize"
              @input="resizeTextarea"
            ></textarea>
            <button type="submit" v-if="walletAddress && points >= 12800">提交</button>
          </form>
          <div v-if="isShipped" class="status">
            <span class="shipped">
              请关注快递单号，注意货物查收!
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { usdtTokenAddress, usdtAbi, contractAddresss, contractABII } from '@/js/contract.js';

export default {
  name: 'item',
  data() {
    return {
      addressInfo: '',
      name: '',
      walletAddress: null,
      shortWalletAddress: '未连接',
      walletBalanceTop: '0',
      points: 0, // 积分属性
      isShipped: false
    };
  },
  mounted() {
    this.connectWallet();
  },
  methods: {
    async connectWallet() {
      if (typeof window.ethereum !== 'undefined') {
        try {
          const provider = new ethers.providers.Web3Provider(window.ethereum, 'any');
          await provider.send("eth_requestAccounts", []);
          const signer = provider.getSigner();
          this.walletAddress = await signer.getAddress();
          this.shortWalletAddress = `地址:${this.walletAddress.slice(0, 5)}...${this.walletAddress.slice(-4)}`;

          // 使用 ERC20 合约获取 USDT 余额
          const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, provider);
          const balance = await usdtContract.balanceOf(this.walletAddress);
          const balanceInUsdt = ethers.utils.formatUnits(balance, 6); // USDT 有 6 位小数
          const balanceInUsdtInt = Math.floor(balanceInUsdt); // 将余额取整
          this.walletBalanceTop = balanceInUsdtInt; // 显示整数余额

          // 加载积分
          this.loadPoints();
          // 加载个人信息
          this.loadUserInfo();
        } catch (error) {
          console.error(error);
          alert('钱包连接失败');
        }
      } else {
        alert('请安装 MetaMask');
      }
    },
    async handleSubmit() {
      if (this.walletAddress && this.points >= 12800) {
        if (confirm('你确认要提交12800积分吗？提交后将无法再次修改。')) {
          try {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const contract = new ethers.Contract(contractAddresss, contractABII, signer);

            // 提交收货地址、姓名到智能合约
            const tx = await contract.storeAddress(this.addressInfo, this.name);
            console.log('Transaction:', tx);
            await tx.wait(); // 等待交易打包完成
            alert('提交成功，请等待发货！');

            // 不记录发货状态
            // this.isShipped = true;

            const deliveryInfo = {
              address: this.addressInfo,
              name: this.name,
              walletAddress: this.walletAddress,
              shipped: false // 保持发货状态为 false
            };
            let deliveryAddresses = JSON.parse(localStorage.getItem('deliveryAddresses')) || [];
            deliveryAddresses.push(deliveryInfo);
            localStorage.setItem('deliveryAddresses', JSON.stringify(deliveryAddresses));

            // 扣除积分
            this.points -= 12800;
            this.savePoints();

            // 清空输入框
            this.addressInfo = '';
            this.name = '';
          } catch (error) {
            console.error('提交到区块链失败:', error);
            alert('提交失败，请重试');
          }
        }
      } else {
        alert('钱包连接失败或积分不足！');
      }
    },
    async loadUserInfo() {
      if (this.walletAddress) {
        try {
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const signer = provider.getSigner();
          const contract = new ethers.Contract(contractAddresss, contractABII, signer);
          const [addressInfo, name] = await contract.getAddress(); // 移除传入的 walletAddress 参数
          this.addressInfo = addressInfo;
          this.name = name;

          // 不再检查发货状态
          // this.loadIsShipped();
        } catch (error) {
          console.error('无法加载用户信息:', error);
        }
      }
    },
    loadIsShipped() {
      let deliveryAddresses = JSON.parse(localStorage.getItem('deliveryAddresses')) || [];
      deliveryAddresses.forEach(item => {
        if (item.walletAddress === this.walletAddress && item.shipped) {
          this.isShipped = true;
        }
      });
    },
    loadPoints() {
      const savedPoints = localStorage.getItem('userPoints');
      if (savedPoints !== null) {
        this.points = parseInt(savedPoints, 10);
      }
    },
    savePoints() {
      localStorage.setItem('userPoints', this.points.toString());
    },
    resizeTextarea(event) {
      const textarea = event.target;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }
};
</script>

<style scoped>
@import "@/assets/css/item.css";
.input-field {
  width: 100%;
  box-sizing: border-box; /* 确保宽度计算包含内边距和边框 */
  margin-bottom: 10px;
  padding: 8px;
  color: #000000; /* 设置字体颜色为黑色 */
}
.card {
  padding: 10px;
  margin: 10px 0;
  border-radius: 8px;
  background-color: #f0f0f0;
  overflow: auto;
  max-height: 200px;
}
form {
  display: flex;
  flex-direction: column;
}
label {
  margin-bottom: 10px;
}
textarea.autoresize {
  resize: none; /* 防止用户手动调整大小 */
  overflow: hidden; /* 隐藏滚动条 */
  min-height: 30px; /* 设置最小高度 */
  color: #000000; /* 设置字体颜色为黑色，确保与输入框一致 */
}
button {
  padding: 10px;
  border-radius: 4px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3;
}
#walletAddress, #walletBalanceTop, #walletBalanceScore {
  color: rgb(255, 102, 0);
}
.status {
  margin-top: 10px;
}
.shipped {
  color: red;
}
</style>